module.exports = __webpack_public_path__ + "img/调皮.58354d04.gif";